import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'
import { DatePreference } from '@npm-client-frontends/client-frontends-shared-types'

interface DateFormatModalProps {
  open: boolean
  onClose: () => void
  onUpdateDateFormat: (
    dateFormat: DatePreference,
    modalAction: (open: boolean) => void,
  ) => Promise<void>
}

const DateFormatButton = ({
  format,
  onClick,
}: {
  format: DatePreference
  onClick: () => void
}) => {
  const buttonText =
    format === DatePreference.MONTH_DAY ? 'US (MM/DD)' : 'International (DD/MM)'
  return <Button onClick={onClick}>{buttonText}</Button>
}

const DateFormatModal: React.FC<DateFormatModalProps> = ({
  open,
  onClose,
  onUpdateDateFormat,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Choose your preferred date format</DialogTitle>
      <DialogContent>
        You can change this setting at any time from the account settings page.
      </DialogContent>
      <DialogActions>
        <DateFormatButton
          format={DatePreference.MONTH_DAY}
          onClick={() => onUpdateDateFormat(DatePreference.MONTH_DAY, onClose)}
        />
        <DateFormatButton
          format={DatePreference.DAY_MONTH}
          onClick={() => onUpdateDateFormat(DatePreference.DAY_MONTH, onClose)}
        />
      </DialogActions>
    </Dialog>
  )
}

export default DateFormatModal
